<template>
  <div style="margin: 0px 30px; padding-top: 20px" class="report-15" dir="rtl">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->

    <!-- <h3 class="text-center">شركة البرمجيات الدقيقة</h3>
      <h3 class="text-center">للحلول البرمجية وخدمات تقنية المعلومات</h3> -->
    <h3 class="text-center">{{ fullName }}</h3>
    <h3 class="text-center">{{ shortName }}</h3>

    <h3 style="font-weight: bold" class="text-center">بطاقة الموظف</h3>

    <section
      style="display: flex; justify-content: space-between"
      class="header"
    >
      <h5 style="padding-top: 45px" class="text-right">
        التاريخ : {{ convert(new Date()) }}
      </h5>

      <div style="width: 110px; margin-bottom: 5px" class="mlogo t-alignlogo">
        <img class="wlogo" :src="allData.personalPicture" />
      </div>
      <!-- <div class="img">
        <div style="height: 134px;
      width: 117px;">
          <p style="text-align: center;
      height: 100%;
      padding-top: 53px;">
            صورة الموظف
          </p>
        </div>
      </div> -->
    </section>
    <section class="body">
      <!-- البيانات الشخصية -->

      <div
        style="
          margin-top: 10px;
          margin-bottom: 35px;
          border: 0.5px solid rgb(67, 160, 71);
        "
        class="marginTop"
      >
        <md-card-header
          style="margin-bottom: 30px"
          class="md-card-header-text md-card-header-green"
        >
          <div class="card-text">
            <h4 class="title">البيانات الشخصية</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <md-table class="paginated-table table-striped table-hover mt-25">
            <md-table-row>
              <md-table-cell class="w-160">الأسم</md-table-cell>

              <md-table-cell class="w-160">رقم الملف الشخصي</md-table-cell>

              <md-table-cell class="w-100">الرقم الوطني</md-table-cell>

              <md-table-cell class="w-70">الجنس</md-table-cell>

              <md-table-cell class="w-100">تاريخ الميلاد</md-table-cell>

              <md-table-cell class="w-70">رقم الهاتف</md-table-cell>

              <md-table-cell class="w-70">العنوان</md-table-cell>

              <md-table-cell class="w-100">الحالة الإجتماعية</md-table-cell>

              <md-table-cell class="w-100">البريد الإلكتروني</md-table-cell>

              <md-table-cell class="w-100">المؤهل العلمي</md-table-cell>

              <md-table-cell class="w-70">التخصص</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell md-label="الصنف">{{
                allData.employeeName
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.profileNumber
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.nationalNumber
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.gender
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                convert(allData.birthDate)
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.phone
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.address
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.socialStatus
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.email
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.scientificAppointment
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.specialization
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </div>

      <!-- البيانات الوظيفية -->

      <div
        style="
          margin-top: 10px;
          margin-bottom: 35px;
          border: 0.5px solid rgb(67, 160, 71);
        "
        class="marginTop"
      >
        <md-card-header
          style="margin-bottom: 30px"
          class="md-card-header-text md-card-header-green"
        >
          <div class="card-text">
            <h4 class="title">البيانات الوظيفية</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <md-table class="paginated-table table-striped table-hover mt-25">
            <md-table-row>
              <md-table-cell class="w-100">الادارة / المكتب </md-table-cell>

              <md-table-cell class="w-100">القسم / المشروع </md-table-cell>

              <md-table-cell class="w-100">الوحدة</md-table-cell>

              <md-table-cell class="w-100">نوع التوظيف</md-table-cell>

              <md-table-cell class="w-100">الصفة الوظيفية</md-table-cell>

              <md-table-cell class="w-100">تاريخ المباشرة </md-table-cell>

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                class="w-100"
                >الدرجة</md-table-cell
              >

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                class="w-100"
                >العلاوة</md-table-cell
              >

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                class="w-160"
                >تاريخ الحصول على الدرجة
              </md-table-cell>

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                class="w-160"
                >تاريخ استحقاق الترقية
              </md-table-cell>

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                class="w-160"
                >شهر استحقاق العلاوة
              </md-table-cell>

              <md-table-cell class="w-160">رصيد الإجازات السنوي </md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell md-label="الصنف">{{
                allData.departmentName
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.sectionName
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.unitName
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.jobType
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.jobDescription
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                convert(allData.jobDate)
              }}</md-table-cell>

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                md-label="الصنف"
                >{{ allData.currentGrade }}</md-table-cell
              >

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                md-label="الصنف"
                >{{ allData.currentBonus }}</md-table-cell
              >

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                md-label="الصنف"
                >{{ convert(allData.lastGradeUpdate) }}</md-table-cell
              >

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                md-label="الصنف"
                >{{ convertYear(allData.upgradeDueDate) }}</md-table-cell
              >

              <md-table-cell
                v-if="allData.jobType != 'عقد' && privateCompanyMode == 'false'"
                md-label="الصنف"
                >{{ allData.monthName }}</md-table-cell
              >

              <md-table-cell md-label="الصنف">{{
                allData.balanceDays
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </div>

      <!-- البيانات المالية -->

      <div
        style="
          margin-top: 10px;
          margin-bottom: 35px;
          border: 0.5px solid rgb(67, 160, 71);
        "
        class="marginTop"
      >
        <md-card-header
          style="margin-bottom: 30px"
          class="md-card-header-text md-card-header-green"
        >
          <div class="card-text">
            <h4 class="title">البيانات المالية</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <md-table class="paginated-table table-striped table-hover mt-25">
            <md-table-row>
              <md-table-cell>رقم الملف المالي </md-table-cell>

              <md-table-cell>المرتب الأساسي </md-table-cell>

              <md-table-cell>رقم الضمان </md-table-cell>

              <md-table-cell>المصرف</md-table-cell>

              <md-table-cell>رقم الحساب</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell md-label="الصنف">{{
                allData.fileNumber
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.basicSalary
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.securityNumber
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.bankBranchName
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.accountNumber
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </div>

      <!--  تقييم -->

      <div
        style="
          margin-top: 10px;
          margin-bottom: 35px;
          border: 0.5px solid rgb(67, 160, 71);
        "
        class="marginTop"
      >
        <md-card-header
          style="margin-bottom: 30px"
          class="md-card-header-text md-card-header-green"
        >
          <div class="card-text">
            <h4 class="title">تقييم الكفاءة لآخر ثلاث سنوات</h4>
          </div>
        </md-card-header>

        <md-card-content>
          <md-table class="paginated-table table-striped table-hover mt-25">
            <md-table-row>
              <md-table-cell class="w-160"
                >{{ allData.numberOfTheYear }}
              </md-table-cell>

              <md-table-cell class="w-160">{{
                allData.numberOfTheYearTwo
              }}</md-table-cell>

              <md-table-cell class="w-160">{{
                allData.numberOfTheYearThree
              }}</md-table-cell>
            </md-table-row>
            <md-table-row>
              <md-table-cell md-label="الصنف">{{
                allData.efficiency
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.efficiencyTwo
              }}</md-table-cell>

              <md-table-cell md-label="الصنف">{{
                allData.efficiencyThree
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </div>
    </section>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["allData", "month", "Date", "fullName", "shortName"],
  data() {
    return {
      privateCompanyMode: false,
      m: env.mTop(),
    };
  },

  async created() {
    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
  },

  methods: {
    convertYear(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getFullYear() + " - " + (d.getMonth() + 1)

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss">
.w-160 .md-table-cell-container {
  width: 160px !important;
}

.w-100 .md-table-cell-container {
  width: 100px !important;
}

/*.md-table-cell:last-child.paginated-table .md-table-cell:last-child .md-table-cell-container, .paginated-table .md-table-head:last-child {
    width: 160px !important;
    padding-left: 0px !important;
  }*/

.img {
  div {
    border: 2px solid rgb(67, 160, 71);
    padding: 10px;
    width: 250px;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
}
</style>